import {
	MimaButton, Searchbar,
} from '../../components';
import styles from '../../assets/styles/Transactions/Transactions.module.scss';
import { amountFormatter } from '../../utils/utils';
import constant from '../../utils/constant';
import moment from 'moment';
import React, { useMemo } from 'react';

const ExpenseDebt = ({
	transactions,
	getUpdateDebtModal,
	goToEditExpenseModal,
	goToEditIncomeModal,
	filteredTransactions,
	setFilteredTransactions,
}) => {

	// const allDebt = transactions.filter(item => {
	// 	return item.type === "DEBT";
	// })

	const allDebt = useMemo(() => {
		const allDebt = transactions.filter(item => {
			return item.type === "DEBT"
		})
		return allDebt;
	}, [transactions])
	
	return (
		<>
			<div className="searchInMiddle">
				<Searchbar
					placeholder="Search Transactions"
					variant="wide"
					input={allDebt}
					loading={false}
					output={setFilteredTransactions}
					handleFilter={(item, searchQuery) => {
						return (
							item?.customer?.fullname
								?.toLowerCase()
								?.includes(searchQuery) ||
							item?.category?.toLowerCase()?.includes(searchQuery) ||
							item?.narration?.toLowerCase()?.includes(searchQuery)
						);
					}}
				/>
			</div>
			<div className="whiteTable">
				<table>
					<thead>
						<tr>
							<th> Created Date </th>
							<th> Narration </th>
							<th> Amount Owed </th>
							<th> Due Date </th>
							<th> Tag Type </th>
							<th> Status </th>
							<th> Action </th>
						</tr>
					</thead>
					<tbody>
						{filteredTransactions.map(
							(transaction, index) =>
								
									<tr key={index}>
										<td>
											{moment(transaction.createdAt).format('DD-MM-YYYY hh:mm')}{' '}
										</td>
										<td>
											{transaction.narration
												? transaction.narration
												: transaction.expenseCategory
													? transaction.expenseCategory.name
													: ''}
										</td>
										<td>
											{amountFormatter(transaction.currencyCode).format(
												parseInt(transaction.deposit)
											)}
										</td>
										<td>
											{' '}
											{moment(
												transaction.balanceDueDate || transaction.dueDate
											).format('DD-MM-YYYY hh:mm')}
										</td>
										<td>
											{transaction.inflowType}
										</td>
										<td
											className={`${transaction.status === 'UNPAID'
												? styles.notPaid
												: transaction.status === 'PAID'
													? styles.paid
													: styles.partPaid
												}`}>
											{transaction?.status}
										</td>
										<td>
											{transaction.status === 'UNPAID' && (
												<MimaButton
													title="Update Status"
													variant="filter"
													width={15}
													onClick={() => getUpdateDebtModal(transaction)}
												/>
											)}
										</td>
									</tr>
								
						)}
					</tbody>
				</table>
			</div>
		</>

	);
};

export default ExpenseDebt;
